module.exports = __webpack_public_path__ + "static/media/spacecol.2d2ec1eb.svg";